import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Grid,
  ListSubheader,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import taxSettingsApi from "../api/taxSettingsApi";
import industryApi from "../api/industryApi";

function TaxSettingsPage() {
  const customerInfor = useSelector((state) => state.auth.customerInfor);

  const [currentSetting, setCurrentSetting] = useState({
    taxCalculationMethod: null,
    revenueGroup: -1,
    determineCost: false,
    industryId: null,
  });
  const [revenueGroup, setRevenueGroup] = useState([]);
  const [taxCalculation, setTaxCalculation] = useState([]);

  useEffect(() => {
    const allOptions = [
      { value: 1, label: "Trực tiếp trên doanh thu" },
      { value: 2, label: "Khấu trừ" },
    ];

    if (
      customerInfor?.customerBusinessTypeId === 1 ||
      customerInfor?.customerBusinessTypeId === 2
    ) {
      // Chỉ lấy value 1
      setTaxCalculation(allOptions.filter((item) => item.value === 1));
    } else if (customerInfor?.customerBusinessTypeId === 3) {
      // Chỉ lấy value 2
      setTaxCalculation(allOptions.filter((item) => item.value === 2));
    } else {
      // Trường hợp khác (nếu cần mặc định hiện cả hai hoặc rỗng)
      setTaxCalculation(allOptions);
    }
  }, [customerInfor?.customerBusinessTypeId]);
  const [industries, setIndustries] = useState([]);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  // Tạo mảng năm từ 1900 đến năm hiện tại (đảo ngược để năm mới nhất lên đầu)
  const years = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, index) => 1900 + index,
  ).reverse();
  const getCurrentQuarter = () => Math.floor((new Date().getMonth() + 3) / 3);
  const [quarter, setQuarter] = useState(getCurrentQuarter());
  const quarters = [
    { value: -1, label: "Tất cả" },
    { value: 1, label: "Quý 1 (Tháng 1 - 3)" },
    { value: 2, label: "Quý 2 (Tháng 4 - 6)" },
    { value: 3, label: "Quý 3 (Tháng 7 - 9)" },
    { value: 4, label: "Quý 4 (Tháng 10 - 12)" },
  ];

  useEffect(() => {
    fetchRevenueGroup();
    //fetchTaxCalculationMethod(customerInfor?.customerBusinessTypeId);
    fetchIndustries();
    fetchTaxSetting();
  }, [customerInfor?.customerBusinessTypeId]);

  const fetchRevenueGroup = async () => {
    try {
      const response = await taxSettingsApi.getAllRevenueGroup();
      if (response.success) {
        setRevenueGroup([
          { value: -1, label: "Tự động" },
          ...response.data.map((item) => ({
            value: item.groupId,
            label: item.groupName,
          })),
        ]);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchTaxCalculationMethod = async (type) => {
    try {
      const response = await taxSettingsApi.getTaxCalculation(type);
      if (response.success) {
        setTaxCalculation([
          ...response.data.map((item) => ({
            value: item.methodId,
            label: item.methodName,
          })),
        ]);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };
  const fetchIndustries = async () => {
    try {
      const response = await industryApi.searchIndustryChoice(
        "",
        0,
        100,
        customerInfor?.CusId,
      );
      if (response.success) {
        setIndustries(response.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchTaxSetting = async () => {
    try {
      const response = await taxSettingsApi.getTaxSetting(customerInfor?.CusId);
      if (response.success) {
        if (response.data === null) {
          setCurrentSetting({
            taxCalculationMethod: null,
            revenueGroup: -1,
            determineCost: false,
          });
        } else setCurrentSetting(response.data);
      } else toast.error(response.message);
    } catch (error) {
      toast.error("Lỗi xử lý dữ liệu:" + error);
    }
  };

  const handleSaveTaxSetting = async () => {
    try {
      const response = await taxSettingsApi.saveTaxSetting(
        customerInfor?.CusId,
        currentSetting.taxCalculationMethod,
        currentSetting.revenueGroup,
        currentSetting.determineCost,
        currentSetting.industryId,
      );
      if (response.success) {
        toast.success("Lưu thành công");
      } else toast.error(response.message);
    } catch (error) {
      toast.error("Lỗi xử lý dữ liệu: " + error);
    }
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{ padding: 2, display: "flex", flexDirection: "column" }}
    >
      <Box>
        <Typography variant="h6">Phương pháp tính thuế</Typography>
        <TextField
          select
          sx={{
            width: 400,
          }}
          size="small"
          value={currentSetting?.taxCalculationMethod ?? -1}
          onChange={(e) => {
            setCurrentSetting((prev) => ({
              ...prev,
              taxCalculationMethod:
                e.target.value === -1 ? null : e.target.value,
            }));
          }}
        >
          {taxCalculation.map((option) => {
            return (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            );
          })}
        </TextField>
        <Typography variant="h6">Nhóm doanh thu</Typography>
        <ToggleButtonGroup
          value={currentSetting?.revenueGroup}
          exclusive // Chỉ cho phép chọn 1 (giống Radio)
          onChange={(e) => {
            setCurrentSetting((prev) => ({
              ...prev,
              revenueGroup: parseInt(e.target.value),
            }));
            if (
              parseInt(e.target.value) !== 1 &&
              parseInt(e.target.value) !== 2
            ) {
              // Nếu chọn "Tự động", reset về null hoặc giá trị mặc định
              setCurrentSetting((prev) => ({
                ...prev,
                determineCost: true, // Mặc định bật "Xác định được" khi chọn nhóm doanh thu cụ thể
              }));
            }
          }}
          color="primary"
          sx={{
            display: "flex",
            flexWrap: "wrap", // Tự động xuống dòng nếu quá dài
            gap: 2, // Khoảng cách giữa các nút (8px * 2 = 16px)
            border: "none", // Ẩn viền bao quanh group
            "& .MuiToggleButtonGroup-grouped": {
              border: "1px solid #ccc !important", // Hiện lại viền cho từng nút
              borderRadius: "8px !important", // Bo góc cho tất cả các nút
              margin: 0, // Xóa margin mặc định
            },
          }}
        >
          {revenueGroup.map((item, index) => {
            return (
              <ToggleButton value={item.value} key={item.value}>
                {item.label}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>

        <Typography variant="h6">
          Chi phí phục vụ sản xuất kinh doanh
        </Typography>
        <RadioGroup
          row
          value={currentSetting?.determineCost || false}
          onChange={(e) =>
            setCurrentSetting((prev) => ({
              ...prev,
              determineCost: e.target.value === "true" ? true : false,
            }))
          }
        >
          <FormControlLabel
            value="true"
            control={<Radio />}
            label="Xác định được"
          />
          <FormControlLabel
            value="false"
            control={<Radio />}
            label="Không xác định"
            disabled={
              currentSetting?.revenueGroup !== 1 &&
              currentSetting?.revenueGroup !== 2
            } // Chỉ cho phép chọn "Không xác định" khi chưa chọn nhóm doanh thu cụ thể
          />
        </RadioGroup>
        <Typography variant="h6">Ngành nghề chính</Typography>
        <TextField
          margin="dense"
          select
          label="Ngành nghề"
          value={currentSetting?.industryId || ""}
          onChange={(e) => {
            const selectedId = e.target.value;
            const selected = industries.find(
              (x) => x.industryId === selectedId,
            );
            setCurrentSetting((prev) => ({
              ...prev,
              industryId: selectedId,
              // industryVatRate: selected?.industryVatRate,
              // industryPitRate: selected?.industryPitRate,
            }));
          }}
          size="small"
          sx={{
            width: 400,
          }}
        >
          {/* Cách gom nhóm đơn giản nhất: dùng Set để lấy danh sách tên nhóm duy nhất */}
          {[...new Set(industries.map((i) => i.industryGroupName))].map(
            (group) => [
              <ListSubheader
                key={group}
                sx={{ fontWeight: "bold", color: "black" }}
              >
                {group}
              </ListSubheader>,
              industries
                .filter((item) => item.industryGroupName === group)
                .map((option) => (
                  <MenuItem
                    key={option.industryId}
                    value={option.industryId}
                    sx={{ pl: 4 }}
                  >
                    {option.industryNameUi}
                  </MenuItem>
                )),
            ],
          )}
        </TextField>
      </Box>
      <Box>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleSaveTaxSetting();
          }}
        >
          Lưu
        </Button>
      </Box>
    </Grid>
  );
}

export default TaxSettingsPage;
